'use client';

import { CapiV2 } from '@/types/capi';
import { DataResponse } from '@/types/strapiBasicResponseProps';
import {
  BlocksRenderer,
  type BlocksContent,
} from '@strapi/blocks-react-renderer';
import classNames from 'classnames';
import Image from 'next/image';
import { Button } from '../buttons';
import { Icon } from '../internalComponents/icon';
import { Container } from '../pageComponents/container/container';
import styles from './ctaBlock.module.scss';

type Props = {
  capis: DataResponse<CapiV2>;
  title: string;
  description: BlocksContent;
};

export const CTABlock = (props: Props) => {
  return (
    <div className="bg-surface-black min-h-52 justify-center py-20">
      <Container size="xWide">
        <div className="flex flex-col-reverse lg:flex-row gap-10">
          <div className="flex flex-col gap-10 flex-1">
            <h1 className="text-lg lg:text-xl font-heading text-primary">
              GET IN TOUCH
            </h1>
            <h2 className="text-5xl lg:text-10xl font-heading text-surface-white">
              {props.title}
            </h2>
            <div
              className={classNames(
                styles.list,
                'lg:text-[1.5rem] text-surface-grey'
              )}
            >
              <BlocksRenderer content={props.description} />
            </div>
            <div>
              <Button
                href="/contact"
                style={{
                  type: 'primary',
                  inverted: true,
                  disabled: false,
                }}
              >
                Get in touch
                <Icon name="ArrowRight" />
              </Button>
            </div>
          </div>
          <div className="flex flex-col flex-1 justify-center">
            <div className="flex gap-5 h-[80%]">
              {props.capis.data.map((capi) => (
                <div
                  key={capi.attributes.thumbnail.data.attributes.url}
                  className="odd:self-end"
                >
                  <div className="relative">
                    <Image
                      className="rounded-lg"
                      width={capi.attributes.thumbnail.data.attributes.width}
                      height={capi.attributes.thumbnail.data.attributes.height}
                      src={capi.attributes.thumbnail.data.attributes.url}
                      alt="call to action image"
                    />
                    <div className="absolute bottom-0 p-4 lg:p-10 lg:text-[1.2rem]">
                      <h1 className="text-surface-white font-semibold">
                        {capi.attributes.firstName} {capi.attributes.lastName}
                      </h1>
                      <h2 className="text-surface-white">
                        {capi.attributes.functionTitle}
                      </h2>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
